export const API_ENDPOINTS = {
    LOGIN: '/user/login',
    FORGOT_PASSWORD: '/user/forgot-password',
    RESET_PASSWORD: '/user/reset-password',
    VERIFY_OTP: '/user/verify-reset-otp',
    RESEND_OTP: '/user/resend-otp',
    CHANGE_PASSWORD: '/user/change-password',
    VIEW_USER: '/user/view-user',
    UPDATE_USER: '/user/update-user',
    GET_USERS: '/user/by-role?role=user',
    UPDATE_TRIES: '/admin/edit-user-tries',
    DEACTIVATE_USER: '/admin/deactivate-user',
    GET_PROVIDERS: '/admin/get-providers',
    APPROVE_PROVIDER: '/admin/approve-provider',
    
    UPLOAD_FILE: '/user/upload-file',
    GET_CATEGORIES: '/category',
    CREATE_CATEGORY: '/category',
    CREATE_SUB_CATEGORY: '/category/{categoryId}/subcategory',
    CREATE_SUB_TO_SUB_CATEGORY: '/category/{subCategoryId}/sub-subcategory',
    UPDATE_CATEGORY: '/category/:id',
    UPDATE_SUB_CATEGORY: '/category/:id',
    UPDATE_SUB_TO_SUB_CATEGORY: '/category/:id',
    DELETE_CATEGORY: '/category/:id',
    DELETE_CATCHUP:'/catchup-locations/:id',
    DELETE_SUB_CATEGORY: '/category/:id',
    DELETE_SUB_TO_SUB_CATEGORY: '/category/:id',
    ADD_CATCHUPS:'/catchup-locations',
    GET_CATCH_UPS:'/catchup-locations',
    UPDATE_CATCHUP: '/catchup-locations/:id',
  };